/*
 * Copyright (c) Siemens AG 2018 ALL RIGHTS RESERVED.
 *
 * Digital Lifecycle Service (DLS)
*/

import React from "react";

// Stateless component
const NavigationBarComponent = props => {
  let sideBarClass;
    if(props.sideBar){
      sideBarClass='dls-ap-sidebar';
    }
    else{
      sideBarClass='dls-ap-sidebar close';
    }
  return <div className={sideBarClass}>{props.children}</div>;
};

export default NavigationBarComponent;
